import React from 'react';
import classNames from 'classnames';

/**
 * PageContainer component - Centers content with max width constraint
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to be contained
 * @param {string} props.className - Additional classes
 */
export default function PageContainer({ children, className, ...rest }) {
  return (
    <div className={classNames('max-w-[1024px] mx-auto', className)} {...rest}>
      {children}
    </div>
  );
}
